import type { PlayerSource } from "@hybrid-iptv/player";

/**
 * The length the seek bar spans and progress is saved against — ONE rule, used
 * by both, so the bar and Continue Watching's "% watched" can never disagree.
 *
 * The caller's `durationSeconds` wins when it is marked exact (catch-up: the
 * panel serves exactly the minutes requested) or when the stream is transcoded
 * (a live-shaped pipe whose transport length is a moving frontier). Otherwise
 * the transport's own measurement wins when it has one, and the caller's number
 * is the fallback when it does not.
 */
export function effectiveDuration(
  source: Pick<PlayerSource, "transcoded" | "durationSeconds" | "durationIsExact"> | null | undefined,
  transportSeconds: number,
): number {
  const known = source?.durationSeconds && source.durationSeconds > 0 ? source.durationSeconds : 0;
  if (known > 0 && (source?.durationIsExact === true || source?.transcoded === true)) return known;
  if (Number.isFinite(transportSeconds) && transportSeconds > 0) return transportSeconds;
  return known;
}
